import * as types from "./types";

export const saveProducts = (products) => (dispatch) =>
    dispatch({ type: types.SET_PRODUCTS, payload: products });
export const setSelectedProduct = (product) => (dispatch) =>
    dispatch({ type: types.SET_SELECTED_PRODUCT, payload: product });
